import { useState , Suspense ,useRef,useEffect } from 'react';
import AppLoading from '../app-loading/app-loading';
import orderServices from '../../services/orders/orderservice';
import CashCollectionListDataTable from './cash-collection-report-dataTabel';
import CashCollectionReportListSearch from './cash-collection-report-search';
import { Card } from 'primereact/card';
import { Toast } from 'primereact/toast';
import { Dialog } from "primereact/dialog";
import PaymentLinkResendList from '../resend-payment-link/resend-payment-link-list';
import CashDataTable from '../cash-report-detail/cash-Datatable';
import OnlinePaymentDataTable from '../onlinepayment-report-detail/onlinepayment-dataTable';

const CashDeposite: React.FC  = () => {

    const [loading, setLoading] = useState(false);
    const toast = useRef<Toast>(null);
    const [dataList,setDataList] = useState<any[]>([]);
    const [sumofSales,setSumofSales] = useState<number>(0);
    const [sumofCash, setSumofCash] = useState<number>(0);
    const [sumofOnline, setSumofOnline] = useState<number>(0);
    const [sumofCredit, setSumofCredit] = useState<number>(0);
    const [visible, setVisible] = useState(false);
    const [startDate, setStartDate] = useState<any>();
    const [endDate, setEndDate] = useState<any>();
    const [userId, setUserId] = useState<any>(null);
    const [cashvisible, setCashvisible] = useState<boolean>(false);
    const [onlinevisible, setOnlinevisible] = useState<boolean>(false);
    const [orderIds, setOrderIds] = useState<any>();

    const fetchOrderIds = async () => {
        try {
            const orderIdList = await orderServices.GetPullPaymentStatusLogs();
            setOrderIds(orderIdList);
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        fetchOrderIds();
    }, []);

    const handelInvoiceUserChange = async (data: any) => {
        setStartDate(data.startDate);
        setEndDate(data.endDate);
        setUserId(data.userId);

        if (!data.startDate || !data.endDate) {
            toast.current?.show({
                severity: 'info',
                summary: 'Info',
                detail: 'Please select the Date filter.',
                life: 3000
            });
            return;
        }

        if (!data.userId && !data.startDate && !data.endDate) {
            // No filter applied, clear data
            setDataList([]);
            setSumofSales(0);
            setSumofCash(0);
            setSumofOnline(0);
            setSumofCredit(0);
            setLoading(false);
            return;
        }

        setLoading(true);
        try {
            const response: any = await orderServices.getCashCollectionReport(data);

            if (response.dataLists && response.dataLists.length > 0) {
                setDataList(response.dataLists);
                setSumofSales(response.dataLists.reduce((acc: any, row: any) => acc + row.totalSales, 0));
                setSumofCash(response.dataLists.reduce((acc: any, row: any) => acc + row.cashAmount, 0));
                setSumofOnline(response.dataLists.reduce((acc: any, row: any) => acc + row.paymentAmount, 0));
                setSumofCredit(response.dataLists.reduce((acc: any, row: any) => acc + row.credit, 0));
            } else {
                setDataList([]);
                setSumofSales(0);
                setSumofCash(0);
                setSumofOnline(0);
                setSumofCredit(0);
            }
        } catch (err) {
            console.error(err);
            setDataList([]);
            setSumofSales(0);
            setSumofCash(0);
            setSumofOnline(0);
            setSumofCredit(0);
        } finally {
            setLoading(false);
        }
    }

    const hideDialog = () => setVisible(false);
    const cashhideDialog = () => setCashvisible(false);
    const onlinehideDialog = () => setOnlinevisible(false);

    const handelShowPaymentLInk = () => dataList.length > 0 && setVisible(true);
    const handelCash = () => dataList.length > 0 && setCashvisible(true);
    const handelOnline = () => dataList.length > 0 && setOnlinevisible(true);

    return (
        <Suspense fallback={<AppLoading />}>
            <Toast ref={toast} />
            <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
                <div className="col-12">                
                    <div className="flex align-items-center justify-content-between flex-wrap gap-2 w-full card-container mb-0">
                        <h5 className="ml-1 mb-0">Collection Report</h5>
                    </div>
                </div>
                <div className='col-12'>
                    <CashCollectionReportListSearch onSearch={handelInvoiceUserChange}/>
                </div>
                <div className='col-12' style={{display:'flex'}}>
                    {/* Total Sales */}
                    <div className='col-3'>
                        <Card title="Total Sales" style={{ color: 'green' }}>
                            <h3 style={{ color: 'gray' }}>
                                {Math.round(sumofSales).toLocaleString('en-gb', { style: 'currency', currency: 'INR' })}
                            </h3>
                            <span style={{ fontWeight:"bold", fontSize:"1.5rem" }}>
                                {sumofSales > 0 ? "100%" : "0%"}
                            </span>
                        </Card>
                    </div>
                    {/* Cash */}
                    <div className='col-3'>
                        <Card title="Cash" style={{ color: 'green' }} onClick={handelCash}>
                            <h3 style={{ color: 'gray' }}>
                                {Math.round(sumofCash).toLocaleString('en-gb', { style: 'currency', currency: 'INR' })}
                            </h3>
                            <span style={{ fontWeight:"bold", fontSize:"1.5rem" }}>
                                {sumofCash > 0 ? ((sumofCash / sumofSales) * 100).toFixed(2) + "%" : "0%"}
                            </span>
                        </Card>
                        <Dialog visible={cashvisible} style={{ width: "70vw" }} header="Cash Report" onHide={cashhideDialog}>
                            <CashDataTable dateFilter={{ startDate, endDate, userId, collectionType: 1 }}/>
                        </Dialog>
                    </div>
                    {/* Online */}
                    <div className='col-3'>
                        <Card title="Online" style={{ color: 'green' }} onClick={handelOnline}>
                            <h3 style={{ color: 'gray' }}>
                                {Math.round(sumofOnline).toLocaleString('en-gb', { style: 'currency', currency: 'INR' })}
                            </h3>
                            <span style={{ fontWeight:"bold", fontSize:"1.5rem" }}>
                                {sumofOnline > 0 ? ((sumofOnline / sumofSales) * 100).toFixed(2) + "%" : "0%"}
                            </span>
                        </Card>
                        <Dialog visible={onlinevisible} style={{ width: "70vw" }} header="Online Payment Report" onHide={onlinehideDialog}>
                            <OnlinePaymentDataTable dateFilter={{ startDate, endDate, userId, collectionType: 2 }}/>
                        </Dialog>
                    </div>
                    {/* Credit */}
                    <div className='col-3'>
                        <Card title="Credit" style={{ color: 'green' }} onClick={handelShowPaymentLInk}>
                            <h3 style={{ color: 'gray' }}>
                                {Math.round(sumofCredit).toLocaleString('en-gb', { style: 'currency', currency: 'INR' })}
                            </h3>
                            <span style={{ fontWeight:"bold", fontSize:"1.5rem" }}>
                                {sumofCredit > 0 ? ((sumofCredit / sumofSales) * 100).toFixed(2) + "%" : "0%"}
                            </span>
                        </Card>
                        <Dialog visible={visible} style={{ width: "70vw" }} header="Account Receivable Report" onHide={hideDialog}>
                            <PaymentLinkResendList dateFilter={{ startDate, endDate, userId }}/>
                        </Dialog>
                    </div>
                </div>
                <CashCollectionListDataTable data={dataList}/>
            </div>
            {loading && <AppLoading />}
        </Suspense>
    )
}

export default CashDeposite;
